import { NavItem } from '../types';
import './Header.css';

interface HeaderProps {
  headerRef?: React.Ref<HTMLElement>;
  navItems: NavItem[];
  activeSection: string;
  isMobileMenuOpen: boolean;
  onSectionChange: (sectionId: string) => void;
  onToggleMobileMenu: () => void;
}

export default function Header({
  headerRef,
  navItems,
  activeSection,
  isMobileMenuOpen,
  onSectionChange,
  onToggleMobileMenu
}: HeaderProps) {
  const handleNavClick = (e: React.MouseEvent<HTMLAnchorElement>, item: NavItem) => {
    if (item.external) {
      setTimeout(() => onToggleMobileMenu(), 0);
      return;
    }

    e.preventDefault();
    const sectionId = item.href.replace('#', '');
    onSectionChange(sectionId);
  };

  return (
    <>
      <header id="header" ref={headerRef}>
        <a
          href="#"
          className="logo"
          onClick={(e) => handleNavClick(e, { label: 'Inicio', href: '#section1' })}
        >
          Tegus Bagel Co.
        </a>
        <ul className="desktop-nav">
          {navItems.filter((item) => !item.mobileOnly).map((item) => (
            <li key={item.href}>
              <a
                href={item.href}
                className={activeSection === item.href.replace('#', '') ? 'active' : ''}
                onClick={(e) => handleNavClick(e, item)}
                target={item.external ? '_blank' : undefined}
                rel={item.external ? 'noreferrer' : undefined}
              >
                {item.label}
              </a>
            </li>
          ))}
        </ul>
        <div
          className={`hamburger ${isMobileMenuOpen ? 'active' : ''}`}
          onClick={onToggleMobileMenu}
        >
          <span></span>
          <span></span>
          <span></span>
        </div>
      </header>

      <nav className={`sidebar ${isMobileMenuOpen ? 'active' : ''}`}>
        <ul>
          {navItems.map((item) => (
            <li key={item.href}>
              <a
                href={item.href}
                onClick={(e) => handleNavClick(e, item)}
                target={item.external ? '_blank' : undefined}
                rel={item.external ? 'noreferrer' : undefined}
              >
                {item.label}
              </a>
            </li>
          ))}
        </ul>
      </nav>
    </>
  );
}
